<template lang="pug">

div

    //- Headline
    //- .ui.segment
    //-     .ui.two.column.centered.middle.aligned.grid
    //-         //- Produktname
    //-         .column
    //-             .ui.header
    //-                 .content {{ product.name }}

    //-         //- Aktion-Dropdown
    //-         .right.aligned.column
    //-             product-action-dropdown(
    //-                 v-bind:product-model='product'
    //-                 v-bind:variant-models='variants'
    //-             )

    //- .ui.secondary.menu
    
    //-      .item
    //-          .ui.header
    //-              .content {{ product.name }}
    //-              .sub.header
    //-                 | {{ type.name }}

    //-      .right.menu
    //-          product-action-dropdown(
    //-              v-bind:product-model='product'
    //-              v-bind:variant-models='variants'
    //-          )

    //- .ui.header
    //-     .content {{ product.name }}
    //-     .sub.header
    //-         | {{ type.name }} {{ mediaProductionPerson ? '- Medienproduktioner: ' + mediaProductionPerson.firstName + ' ' + mediaProductionPerson.lastName : '' }}

    .ui.secondary
        product-summary(
            v-bind:product="product"
            v-bind:campaign="campaign"
            v-bind:company="company"
            v-bind:job-models="jobs"
            v-bind:mediaProductionPerson="mediaProductionPerson"
            v-bind:priceModels="priceModels"
            v-bind:type="type"
        )

    .ui.segment

        //- Sub-Navi des Produkts
        sub-navigation(v-bind:product-model='product')

        //- Varianten-Navigation
        variant-navigation(
            v-if='variantNavigationPosition === "TOP"'
            v-bind:active-variant='activeVariant'
            v-bind:field-models='fieldModels'
            v-bind:form-model='formModel'
            v-bind:product='product'
            v-bind:variants='variants'
        )

        //- Embedded view
        router-view

        //- Varianten-Navigation
        variant-navigation(
            v-if='variantNavigationPosition === "BOTTOM"'
            v-bind:active-variant='activeVariant'
            v-bind:field-models='fieldModels'
            v-bind:form-model='formModel'
            v-bind:product='product'
            v-bind:variants='variants'
        )

        //- Footer
        .ui.basic.segment
            .ui.four.column.very.relaxed.divided.grid

                //- Allgemeine Informationen & Unternehmensnotiz
                .column

                    h5 Allgemeine Informationen:
                    general-information(
                        v-bind:agency-models='agencies'
                        v-bind:campaign-models='campaigns'
                        v-bind:company-model='company'
                        v-bind:person-models='persons'
                        v-bind:product-model='product'
                    )

                    //- Bemerkungen zum Unternehmen
                    company-note(v-bind:company-model='company')

                //- Variantendetails
                .column

                    h5 Variantendetails:
                    variant-details(
                        v-bind:label-width="50"
                        v-bind:field-models='fieldModels'
                        v-bind:form-model='formModel'
                        v-bind:variant-model='activeVariant'
                    )

                //- Proof & Bemerkungen zum Produkt
                .column
                    h5 Proof & Notizen zum Produkt:
                    proof-details(
                        v-bind:proof-model='proofModel'
                        v-bind:shipping-address-models='shippingAddressModels'
                    )
                    .ui.hidden.divider
                    notice-field(v-bind:product="product")

                //- Lieferanten
                .column
                    h5 Angefragte Lieferanten:
                    job-list(
                        v-bind:address-models='addresses'
                        v-bind:job-models='jobModelsByVariant'
                        v-bind:offer-models='offers'
                        v-bind:product-model='product'
                        v-bind:supplier-models='suppliers'
                        v-bind:variant-models='variants'
                        v-if="product.status !== 'OPEN'"
                    )
                    p.ui.info.message(v-else) Lieferanten können im derzeitigen Produktstatus nicht angefragt werden

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import { type_id_to_form_id } from '@/utils/form'
    import CompanyNote from '@/components/products/view/CompanyNote'
    import ProductActionDropdown from '@/components/products/ProductActionDropdown'
    import GeneralInformation from '@/components/products/GeneralInformation'
    import JobList from '@/components/products/JobList'
    import NoticeField from '@/components/products/view/ProductNote'
    import ProductSummary from '@/components/products/Summary'
    import ProofDetails from '@/components/products/view/ProofDetails'
    import SubNavigation from '@/components/products/SubNavigation'
    import VariantDetails from '@/components/products/VariantDetails'
    import VariantNavigation from '@/components/products/VariantNavigation'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {

        async beforeRouteEnter(to, from, next) {
            const productId = Number(to.params.id)
            const variantId = Number(to.params.variantId)

            const [ productModel, jobModels, supplierModels ] = await Promise.all([

                // Produkt laden
                store.dispatch('products/loadOne', { id: productId }),

                // Jobs laden
                store.dispatch('jobs/loadAllByProductId', { productId }),

                // Lieferanten laden
                store.dispatch('companies/loadAllByIsSupplier'),

                // Benutzer des Produkts laden
                store.dispatch('users/loadAllByProductId', { productId }),

                // Personen des Produkts laden laden
                store.dispatch('persons/loadAllByProductId', { productId }),

                // Varianten laden
                store.dispatch('variants/loadAllByProductId', { productId }),

                // Agenturen laden
                store.dispatch('companies/loadAllByIsAgency'),

                // Preise laden
                store.dispatch('prices/loadAllByVariantId', { variantId }),

                // Felder der Variante laden
                store.dispatch('fields/loadAllByVariantId', { variantId })

            ])

            const [ companyModel ] = await Promise.all([

                // Unternehmen laden
                store.dispatch('companies/loadOne', { id: productModel.company }),

                // Benutzer des Unternehmens laden
                store.dispatch('users/loadAllByCompanyId', { companyId: productModel.company }),

                // Personen des Unternehmens laden
                store.dispatch('persons/loadAllByCompanyId', { companyId: productModel.company }),

                // Produkt-Typ laden
                store.dispatch('productTypes/loadOne', { id: productModel.type }),

                // Angebot laden
                store.dispatch('offers/loadAllByJobModels', { jobModels }),

                // Formular laden
                store.dispatch('forms/loadOne', { id: type_id_to_form_id(productModel.type) }),

                // Kampagnen laden
                store.dispatch('campaigns/loadAllByCompanyId', { companyId: productModel.company }),

                // Addressen der Lieferanten laden
                R.compose(

                    promises => Promise.all(promises),

                    R.map(id => store.dispatch('addresses/loadOne', { id })),

                    R.reject(R.isNil),

                    R.map(R.prop('defaultBillingAddress'))

                )(supplierModels),

                // ggf. Proof laden
                R.when(
                    R.is(Number),
                    proofId => store.dispatch('proofs/loadOne', { id: proofId }),
                    productModel.proof
                )

            ])

            const [ billindAddressModel ] = await Promise.all([

                // Standard-Rechnungsadresse des Unternehmens laden
                store.dispatch('addresses/loadOne', { id: companyModel.defaultBillingAddress }),

                // Lieferadressen laden
                store.dispatch('addresses/loadAllByCompanyIdAndIsShippingAddress', { companyId: companyModel.id }),

            ])

            await Promise.all([

                // Land der Rechnunsadresse lande
                store.dispatch('states/loadAllByCountry', { countryId: billindAddressModel.country }),

                // Bundeslaender der Adresse laden
                store.dispatch('states/loadAllByCountry', { countryId: billindAddressModel.country })

            ])

            next()
        },

        async beforeRouteUpdate(to, from, next) {
            const variantId = to.params.variantId

            await Promise.all([

                // Variante laden
                this.$store.dispatch('variants/loadOne', { id: variantId }),

                // Felder der Variante laden
                store.dispatch('fields/loadAllByVariantId', { variantId })

            ])

            next()
        },

        components: {
            ProductActionDropdown, CompanyNote, GeneralInformation, JobList, NoticeField, ProductSummary,
            ProofDetails, SubNavigation, VariantDetails, VariantNavigation
        },

        computed: {

            activeVariant() {
                return R.find(R.propEq('id', this.variantId), this.variants)
            },

            addresses() {
                return store.getters['addresses/all']
            },

            agencies() {
                return store.getters['companies/allByIsAgencyOfCompanyId'](this.company.id)
            },

            billingAddressModel() {
                return R.compose(

                    // Adresse holen
                    store.getters['addresses/byId'],

                    // ID der Standard-Rechnungsadresse lesen
                    R.prop('defaultBillingAddress')

                )(this.company)
            },

            campaign() {
                return R.cond([

                    // Default-Wert
                    [R.isNil, R.always({})],

                    // Kampagne anhand von ID holen
                    [R.T, store.getters['campaigns/byId']],

                ])(this.product.campaign)
            },

            campaigns() {
                return store.getters['campaigns/allByCompanyId'](this.company.id)
            },

            company() {
                return store.getters['companies/byId'](this.product.company)
            },

            fieldModels() {
                return store.getters['fields/allByVariantId'](this.variantId)
            },

            formModel() {
                return this.$store.getters['forms/byId'](type_id_to_form_id(this.product.type))
            },

            jobs() {
                return this.$store.getters['jobs/allByProductId'](this.product.id)
            },

            jobModelsByVariant() {
                return R.compose(

                    // Jobs anhand von ID holen
                    R.map(R.find(R.__, this.jobs)),

                    // Predicate fuer Job-Suche erstellen
                    R.map(R.propEq('id')),

                    // Doppelungen in Job-IDs entfernen
                    R.uniq,

                    // Job-IDs aus Angeboten lesen
                    R.map(R.prop('job'))

                )(this.offerModelsByActiveVariant)
            },

            offerModelsByActiveVariant() {
                return R.filter(R.propEq('variant', this.activeVariant.id), this.offers)
            },

            mediaProductionPerson() {
                const user = this.$store.getters['users/byId'](this.product.mediaProduction)
                return this.$store.getters['persons/byId'](user.person)
            },

            offers() {
                return R.compose(

                    // flatten
                    R.flatten,

                    // Angebote zu Job-IDs holen
                    R.map(store.getters['offers/allByJobId']),

                    // Job-IDs auslesen
                    R.map(R.prop('id'))

                )(this.jobs)
            },

            priceModels() {
                return store.getters['prices/allByVariantId'](this.variantId)
            },

            product() {
                return store.getters['products/byId'](this.productId)
            },

            proofModel() {
                return store.getters['proofs/byId'](this.product.proof)
            },

            persons() {
                return store.getters['persons/allByCompanyId'](this.product.company)
            },

            productId() {
                return parseInt(this.$route.params.id)
            },

            shippingAddressModels() {
                return store.getters['addresses/allByCompanyIdAndIsShippingAddress'](this.company.id)
            },

            suppliers() {
                return this.$store.getters['companies/allByIsSupplier']
            },

            type() {
                return store.getters['productTypes/byId'](this.product.type)
            },

            variantNavigationPosition() {
                return this.$route.meta.variantNavigationPosition || 'TOP'
            },

            variantId() {
                return Number(this.$route.params.variantId)
            },

            variants() {
                return store.getters['variants/allByProductId'](this.productId)
            },

        },

        mounted() {
            this._connectSseForAllJobs()
        },

        beforeDestroy() {
            this._disconnectSse()
        },

        watch: {
            // Wenn neue Jobs für das Produkt geladen werden (z.B. nach Anlage),
            // SSE-Verbindungen neu aufbauen
            'jobs.length'(newLen, oldLen) {
                if (newLen !== oldLen) {
                    this._disconnectSse()
                    this._connectSseForAllJobs()
                }
            }
        },

        methods: {

            async _connectSseForAllJobs() {
                this._sseConnections = []
                for (const job of this.jobs) {
                    await this._connectSseForJob(job.id)
                }
            },

            async _connectSseForJob(jobId) {
                try {
                    const token = await store.dispatch('offers/getSseToken')
                    const productId = this.productId
                    const es = new EventSource(`/api/v1/offers/events?jobId=${jobId}&token=${token}`)

                    es.addEventListener('job-updated', () => {
                        // Alle Jobs + Angebote des Produkts neu laden
                        store.dispatch('jobs/loadAllByProductId', { productId, force: true }).then(jobModels => {
                            store.dispatch('offers/loadAllByJobModels', { jobModels, force: true })
                        })
                    })

                    es.onerror = () => {
                        es.close()
                        this._sseConnections = this._sseConnections.filter(c => c !== es)
                        const timer = setTimeout(() => this._connectSseForJob(jobId), 5000)
                        this._sseReconnectTimers = (this._sseReconnectTimers || []).concat(timer)
                    }

                    this._sseConnections.push(es)
                } catch (e) {
                    // Stiller Fehler – SSE ist optional
                }
            },

            _disconnectSse() {
                (this._sseReconnectTimers || []).forEach(t => clearTimeout(t))
                this._sseReconnectTimers = [];
                (this._sseConnections || []).forEach(es => es.close())
                this._sseConnections = []
            }

        },

    }
</script>
